import { z } from "zod";
import { TFunction } from "i18next";
import { subYears } from "date-fns";

export const MissingCustomerSchema = (t: TFunction) => {
  return z.object({
    salutation: z.string({
      required_error: t("missingCustomer.validation.salutationRequired"),
    }),
    firstName: z.string({
      required_error: t("missingCustomer.validation.firstName"),
    }).min(1, t("missingCustomer.validation.firstName")),
    lastName: z.string({
      required_error: t("missingCustomer.validation.lastName"),
    }).min(1, t("missingCustomer.validation.lastName")),
    email: z.string({
      required_error: t("missingCustomer.validation.emailRequired"),
    }).email(t("missingCustomer.validation.emailInvalid")),
    telefon: z.string().optional(),
    street: z.string({
      required_error: t("missingCustomer.validation.street"),
    }).min(1, t("missingCustomer.validation.street")),
    houseNumber: z.string({
      required_error: t("missingCustomer.validation.houseNumber"),
    }).min(1, t("missingCustomer.validation.houseNumber")),
    postalCode: z
      .string({
        required_error: t("missingCustomer.validation.postalCode"),
      })
      .min(4, t("missingCustomer.validation.postalCode"))
      .max(10, t("missingCustomer.validation.postalCode")),
    city: z.string({
      required_error: t("missingCustomer.validation.city"),
    })
    .min(1, t("missingCustomer.validation.city"))
    .regex(/^[a-zA-ZäöüÄÖÜß\s\-'.]+$/, { 
      message: "Bitte geben Sie einen gültigen Ortsnamen ein (erlaubt: Buchstaben, Bindestriche, Apostrophe und Leerzeichen)"
    })
    .transform((val) => val.trim()),
    country: z.string({
      required_error: t("missingCustomer.validation.countryRequired"),
    }),
    dateOfBirth: z
      .date({
        required_error: t("missingCustomer.validation.dateRequired"),
        invalid_type_error: t("missingCustomer.validation.dateInvalid"),
      })
      .refine((date) => date <= subYears(new Date(), 16), {
        message: t("missingCustomer.validation.dateRange"),
      }),
    marketingAccepted: z.boolean().default(true),
  });
};
